<template>
  <div class="bs-Step">
    <slot name="step-title" />

    <BookingDemo @click="onLinkClick" />
  </div>
</template>

<script setup>
import { isUndefined, lowerCase } from 'lodash'

import { tracker } from '@/tracking/amplitude'
import { EVENT_CATEGORIES } from '@/tracking/amplitude-helpers'
import { ONBOARDING_ROLES } from '@/utils/components-configurations/onboarding-hub'
import { includesValue } from '@/utils/prop-validators'
import { IS_DEVELOPMENT } from '@root/app-modes'

import BookingDemo from '@/components/ui/onboarding/BookingDemo'

defineOptions({
  name: 'BookingStep'
})

const props = defineProps({
  role: {
    type: String,
    required: true,
    validator: v => includesValue(v, ONBOARDING_ROLES)
  }
})

const TRACKING_BY_BOX_ID = {
  demo: 'product demo',
  consulting: 'consulting'
}

const onLinkClick = box => {
  const eventName = TRACKING_BY_BOX_ID[box.tracking]
  if (!isUndefined(eventName)) {
    tracker.logEvent('clicked demo link', {
      category: EVENT_CATEGORIES.ONBOARDING,
      value: eventName,
      role: lowerCase(props.role)
    })
  } else {
    if (IS_DEVELOPMENT) {
      console.error('No tracking value found for box', box)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/wizard-steps';

.bs-Step {
  @extend %wizard-step-styles;
}
</style>
